import { Box, Grid, Stack, Typography } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../shared/auth/useAuth';
import { KpiCard } from '../components/KpiCard';
import { PendenciasList, type PendenciaItem } from '../components/PendenciasList';
import { useDashboardPending } from '../hooks';

export function ColaboradorHomePage(): JSX.Element {
  const { t } = useTranslation();
  const { user } = useAuth();
  const pending = useDashboardPending();

  const items: PendenciaItem[] = [
    {
      key: 'nfsAEnviar',
      label: t('features.dashboard.pendencias.colab.nfsAEnviar'),
      count: pending.data?.nfsAEnviar ?? 0,
      to: '/me/notas-fiscais',
      icon: <ReceiptLongIcon fontSize="small" color="warning" />,
      severity: 'warning',
    },
    {
      key: 'diasSemApontamento',
      label: t('features.dashboard.pendencias.colab.diasSemApontamento'),
      count: pending.data?.diasSemApontamento ?? 0,
      to: '/me/apontamentos',
      icon: <EventBusyIcon fontSize="small" color="error" />,
      severity: 'error',
    },
  ];

  return (
    <Box>
      <Stack spacing={0.5} sx={{ mb: 2 }}>
        <Typography variant="h5" component="h1">
          {t('features.dashboard.colab.greeting', { nome: user?.nome.split(' ')[0] ?? '' })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('features.dashboard.colab.subtitle')}
        </Typography>
      </Stack>

      <Box sx={{ mb: 2 }}>
        <PendenciasList
          title={t('features.dashboard.pendencias.title')}
          items={items}
          loading={pending.isLoading}
        />
      </Box>

      <Typography variant="overline" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
        {t('features.dashboard.colab.shortcuts')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <KpiCard
            label={t('features.dashboard.colab.apontamentos')}
            value={t('features.dashboard.colab.open')}
            icon={<AccessTimeIcon />}
            to="/me/apontamentos"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KpiCard
            label={t('features.dashboard.colab.vales')}
            value={t('features.dashboard.colab.open')}
            icon={<RequestQuoteIcon />}
            to="/me/vales"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KpiCard
            label={t('features.dashboard.colab.notasFiscais')}
            value={t('features.dashboard.colab.open')}
            icon={<ReceiptLongIcon />}
            to="/me/notas-fiscais"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
